import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {translate} from "react-i18next";

import { signContract } from '../../actions';


@translate(['register'], {wait:true})
class SigningStep extends Component {
  componentDidMount() {
    this.props.handleContractSign();
  }

  render() {
    const {t} = this.props;

    return (
      <div className="container">
        <div className="welcomeBox">
          <h3>{t('register:device_activation')}</h3>
          <p>{t('register:connecting')}</p>
        </div>
        <div className="element-img-wrap">
          <img src="images/img-element.png" alt="element"/>
          <div className="puls-wrap"><em></em><em></em><em></em></div>
        </div>
      </div>
    );
  }
}

SigningStep.propTypes = {
  handleContractSign: PropTypes.func,
};

export default connect(
  () => ({}),
  (dispatch) => {
    return {
      handleContractSign() {
        return dispatch(signContract());
      },
    };
  }
)(SigningStep);



// WEBPACK FOOTER //
// ./src/components/Auth/Registration/Steps/SigningStep.js